<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="编辑菜单"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 style="width: 40%;margin: 20px auto 0 auto;" autocomplete="off">
            <el-form-item label="上级" prop="pid">
                <el-select v-model="ruleForm.pid" placeholder="请选择类型"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allmenu"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="名称" prop="module_name">
                <el-input type="text" v-model="ruleForm.module_name" placeholder="请输入功能名称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="页面名称" prop="name">
                <el-input type="text" v-model="ruleForm.name" placeholder="请输入页面名称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="跳转地址" prop="path">
                <el-input type="text" v-model="ruleForm.path" placeholder="请输入跳转地址" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="图标" prop="icon">
                <el-input type="text" v-model="ruleForm.icon" placeholder="请输入图标" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input type="number" v-model="ruleForm.sort" min="1" placeholder="请输入排序号" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="是否有子菜单" prop="menu_more" v-if="ruleForm.pid == 1">
                <el-radio-group v-model="ruleForm.menu_more">
                    <el-radio :label="2">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否在左侧显示" prop="showleft">
                <el-radio-group v-model="ruleForm.showleft">
                    <el-radio :label="2">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否显示">
                <el-radio-group v-model="ruleForm.showflag">
                    <el-radio :label="2">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="上级名称" prop="menu_parent" v-if="ruleForm.showleft == 2">
                <el-input type="text" v-model="ruleForm.menu_parent" placeholder="请输入上级名称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";

export default {
    created() {

        if (this.$route.params) {
            let meta = JSON.parse(this.$route.params.meta)
            this.ruleForm.id = parseInt(this.$route.params.id)
            this.ruleForm.pid = this.$route.params.pid
            this.ruleForm.module_name = this.$route.params.module_name
            this.ruleForm.name = this.$route.params.name
            this.ruleForm.menu_parent = meta.menu_parent
            this.ruleForm.path = this.$route.params.path
            this.ruleForm.icon = meta.icon
            this.ruleForm.sort = parseInt(this.$route.params.sort)
            this.ruleForm.showflag = parseInt(this.$route.params.showflag) == 1 ? 1 : 2;

            if (meta.noshowdropDown && meta.noshowdropDown==1) {
                this.ruleForm.menu_more = 2
            } else {
                this.ruleForm.menu_more = 1
            }

            if (meta.isSidebarItem && parseInt(meta.isSidebarItem) == 1) {
                this.ruleForm.showleft = 1
            } else {
                this.ruleForm.showleft = 2
            }
        }
    },
    mounted() {
        this.getList()
    },
    data() {
        return {
            isPage: [
                {name: '有界面可访问菜单', id: 1},
                {name: '无界面可访问菜单', id: 0},
            ],
            allmenu: [],
            ruleForm: {
                module_name: "",
                id: "",
                pid: "1",
                name: '',
                path: '',
                icon: '',
                menu_parent: '',
                sort: 99,
                showleft: 1,
                menu_more: 1,
                showflag: 1,
            },
            rules: {
                module_name: [
                    {required: true, message: "请输入功能名称", trigger: "blur"},
                ],
                pid: [
                    {required: true, message: "请选择上级", trigger: "blur"},
                ],
                name: [
                    {required: true, message: "请输入页面名称", trigger: "blur"},
                ],
                path: [
                    {required: true, message: "请输入跳转链接", trigger: "blur"},
                ],
                icon: [
                    {message: "请输入图标", trigger: "blur"},
                ],
                menu_parent: [
                    {message: "请输入上级名称", trigger: "blur"},
                ],
                sort: [
                    {required: true, message: "请输入排序号", trigger: "blur"},
                ],
                showleft: [
                    {required: true, message: "请选择是否在左侧显示", trigger: "blur"},
                ],
                showflag: [
                    {required: true, message: "请选择是否隐藏", trigger: "blur"},
                ],
                menu_more: [
                    {required: true, message: "请选择是否有子菜单", trigger: "blur"},
                ],
            },
            is_submit: false,
        };
    },
    methods: {
        // 获取所有设备类型
        getList() {
            let params = {
                servername: 'Ruyi_AdminSystemServices',
                method: 'getMenu',
                params: {
                    add_menu: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                let menu = [];
                for (var i = 0; i < res.data.data.list.length; i++) {
                    menu.push({
                        id: res.data.data.list[i].id,
                        name: res.data.data.list[i].module_name,
                    })

                    if (res.data.data.list[i].children) {
                        for (var j = 0; j < res.data.data.list[i].children.length; j++) {
                            if (j == res.data.data.list[i].children.length - 1) {
                                menu.push({
                                    id: res.data.data.list[i].children[j].id,
                                    name: "│   └   "+res.data.data.list[i].children[j].module_name,
                                })
                            } else {
                                menu.push({
                                    id: res.data.data.list[i].children[j].id,
                                    name: '│   ├   '+res.data.data.list[i].children[j].module_name,
                                })
                            }
                        }
                    }
                }

                this.allmenu = menu
            });
        },
        // 返回上一页
        goBack() {
            window.history.go(-1);
            // window.close()
        },

        // 提交表单
        submitForm(formName) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let _that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        'servername': 'Ruyi_AdminSystemServices',
                        'method': 'editMenu',
                        'params': {
                            module_name: this.ruleForm.module_name,
                            id: this.ruleForm.id,
                            pid: this.ruleForm.pid,
                            name: this.ruleForm.name,
                            path: this.ruleForm.path,
                            icon: this.ruleForm.icon,
                            sort: this.ruleForm.sort,
                            showleft: this.ruleForm.showleft,
                            showflag: this.ruleForm.showflag,
                            menu_more: this.ruleForm.menu_more,
                            menu_parent: this.ruleForm.menu_parent,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '修改成功',
                            duration: 1500,
                            onClose: function () {
                                _that.is_submit = false;
                                window.history.go(-1);
                            }
                        });
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    this.is_submit = false;
                    return false;
                }
            });
            this.is_submit = false;
        },
    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 316px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 316px;
    height: 200px;
    display: block;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}
</style>
